import { useDispatch, useSelector } from "react-redux";
import { cacheApiRequest } from "../utils/cacheApiRequest";
import { clearCache, clearAllCacheForBaseKey } from "../store/cacheSlice";

export const useDashboardService = () => {
  const dispatch = useDispatch();
  const cache = useSelector(state => state.cache.cache);

  const fetchSummaryCounts = async (params = {asOnDate:'2025-02-05'}, forceRefresh = false) => {
    const key = "DASHBOARD_GET_BUSINESS_VERTICAL_COUNTS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

    const fetchCheckInStats = async (params = {asOnDate:'2025-02-05'}, forceRefresh = false) => {
    const key = "DASHBOARD_GET_CHECKIN_STATS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

   const fetchCheckInStatsByHour = async (params = {asOnDate:'2025-02-05'}, forceRefresh = false) => {
    const key = "DASHBOARD_GET_CHECKIN_STATS_BY_HOUR";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

   const fetchBVWisrCheckInStats = async (params = {asOnDate:'2025-02-05'}, forceRefresh = false) => {
    const key = "DASHBOARD_GET_BV_CHECKIN_STATs";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  
  

  return { fetchSummaryCounts, fetchCheckInStats, fetchCheckInStatsByHour, fetchBVWisrCheckInStats };
};

 